import React, { createContext, useContext, useState } from 'react';

const PreloaderContext = createContext();

export const usePreloader = () => useContext(PreloaderContext);

export const PreloaderProvider = ({ children }) => {
  const [isPreloaderDone, setIsPreloaderDone] = useState(false);

  return (
    <PreloaderContext.Provider value={{ isPreloaderDone, setIsPreloaderDone }}>
      {children}
    </PreloaderContext.Provider>
  );
};
